import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ApiBaseUrl, signUpClient } from "../../Utils/Constants";
import { showToast } from "../../Helper/Toast";

export const hitSignUpClientApi = createAsyncThunk(
  "hitSignUpClientApi",
  async (payload) => {
    try {
      const config = {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      };
      const url = ApiBaseUrl + signUpClient;
      const response = await axios.post(url, payload, config);
      return response.data;
    } catch (error) {
      // showToast(
      //   error.response?.data?.message || "Sign up failed",
      //   "error",
      // );
      throw error.response?.data;
    }
  },
);

const signUpClientSlice = createSlice({
  name: "signUpClientReducer",
  initialState: {
    isLoading: false,
    data: null,
  },
  reducers: {
    clearSignUpClientData: (state) => {
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(hitSignUpClientApi.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(hitSignUpClientApi.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
        if (
          action.payload?.status === true &&
          action.payload?.data?.accessToken
        ) {
          localStorage.setItem("clientToken", action.payload.data.accessToken);
          localStorage.setItem("clientId", action.payload.data._id);
          localStorage.setItem(
            "clientData",
            JSON.stringify(action.payload.data),
          );
        }
      })
      .addCase(hitSignUpClientApi.rejected, (state) => {
        state.isLoading = false;
      });
  },
});

export const { clearSignUpClientData } = signUpClientSlice.actions;
export default signUpClientSlice.reducer;
